import { csrfToken, isIosLikeDevice, isStandaloneDisplay } from "@/lib/web-push"
import { memberInstallPath, memberPwaDevicesPath } from "@/routes"

const CLIENT_ID_KEY = "triyoga-pwa-device-id"
const registeredUserIds = new Set<number>()

export type PwaFormFactor = "mobile" | "desktop"
export const PWA_INSTALL_TAB_CHANGE_EVENT = "triyoga:pwa-install-tab-change"

export function pwaInstallPath(formFactor: PwaFormFactor): string {
  return memberInstallPath({ tab: formFactor })
}

export function selectPwaInstallTab(formFactor: PwaFormFactor): void {
  if (typeof window === "undefined") return

  window.history.replaceState(
    window.history.state,
    "",
    pwaInstallPath(formFactor),
  )
  window.dispatchEvent(new Event(PWA_INSTALL_TAB_CHANGE_EVENT))
}

export function pwaFormFactor(): PwaFormFactor {
  if (typeof navigator === "undefined") return "desktop"
  if (isIosLikeDevice()) return "mobile"
  if (/Android/i.test(navigator.userAgent)) return "mobile"
  return "desktop"
}

export function pwaClientId(): string {
  const existing = window.localStorage.getItem(CLIENT_ID_KEY)
  if (existing) return existing

  const nextId = crypto.randomUUID()
  window.localStorage.setItem(CLIENT_ID_KEY, nextId)
  return nextId
}

export async function registerPwaDeviceIfStandalone(
  userId: number,
): Promise<boolean> {
  if (!isStandaloneDisplay() || registeredUserIds.has(userId)) return false

  try {
    const response = await fetch(memberPwaDevicesPath(), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
      },
      body: JSON.stringify({
        client_id: pwaClientId(),
        form_factor: pwaFormFactor(),
      }),
    })

    if (!response.ok || response.redirected) return false

    registeredUserIds.add(userId)
    return true
  } catch {
    return false
  }
}
